export default __webpack_public_path__ + "static/media/loading.31b87a06.png";